module.exports = __webpack_public_path__ + "components/country-flag/static/bd-fe485a24a4c2f91beb3ba3d98b13ea3a.svg";